module.exports = __webpack_public_path__ + "img/porsche.978c60d1.png";